import ReactECharts from "echarts-for-react";

interface DonutItem {
  name: string;
  value: number;
}

interface DonutChartProps {
  data: DonutItem[];
  colors?: string[];
  height?: number;
}

export function DonutChart({ data, colors, height = 220 }: DonutChartProps) {
  const option = {
    tooltip: { trigger: "item", formatter: "{b}: {c} ({d}%)" },
    legend: { bottom: 0, type: "scroll", textStyle: { fontSize: 11 } },
    color: colors,
    series: [
      {
        type: "pie",
        radius: ["45%", "70%"],
        center: ["50%", "42%"],
        data,
        label: { show: false },
        emphasis: { label: { show: true, fontSize: 13, fontWeight: "bold" } },
      },
    ],
  };

  return (
    <ReactECharts option={option} style={{ width: "100%", height }} notMerge />
  );
}
